import { getLocalStoragePrivate, setLocalStoragePrivate } from '@/utils/storage-tools';

const BANNER_SHOW_STORAGE_KEY = 'banner';

/**
 * 设置banner显示状态
 *
 * @param {number} id
 * @param {boolean} isShow
 */
export const setBannerShowStateToStorage = function (id: number, isShow: boolean) {
  if (!id) {
    return;
  }

  setLocalStoragePrivate({ id: `${id}`, key: BANNER_SHOW_STORAGE_KEY, data: { isShow } });
};

/**
 * 获取banner显示状态
 *
 * @param {number} id
 */
export const getBannerShowStateFromStorage = function (id: number) {
  if (!id) {
    return false;
  }
  const data = getLocalStoragePrivate({ id: `${id}`, key: BANNER_SHOW_STORAGE_KEY });
  if (data) {
    return !!data.isShow;
  }

  // 默认展示
  return true;
};
